/**
 * 拼团取餐方式切换
 */
import React from 'react'
import { buyTogetherMobx } from '@mobxStore'
import { classNames } from '@dt/fe-utils'
import { Icon } from '@cps'
import './index.scss'

export interface IEatTypeSwitcherProps {
  types: any;
  value: TEntryType;
  onChange: (value: TEntryType) => void;
}

const TypeSwitcher: React.FC<IEatTypeSwitcherProps> = (props) => {
  const { types, value, onChange } = props

  return (
    <div className='multi-spell-type-swicher'>
      {
        buyTogetherMobx.btEatEntries.map(({ type, name, icon = '', pic = '', disabled = false, mode }, index) => {
          return (
            <div
              key={index}
              className={classNames('type-item-wrapper', { active: value === type, disabled })}
              onClick={() => !disabled && onChange(type)}
            >
              <div className='type-item-content'>
                <div className='type-icon-wrap'>
                  {mode === 0 ? <Icon icon='dicon' name={String(icon)} /> : <img src={pic} />}
                </div>
                <div className='type-info'>
                  <p className='type-name'>{name || i18n.t(`menu.buyTogether.btn_${type}`)}</p>
                </div>
              </div>
              {
                value === type && (
                  <div className='active-icon-wrap'><div className='active-icon'><Icon name='check' /></div></div>
                )
              }
            </div>
          )
        })
      }
    </div>
  )
}

export default TypeSwitcher
